<template>
    <vConsumptionComponent :postList="postList" v-if="flag"></vConsumptionComponent>
</template>
<script>
import vConsumptionComponent from '../../listComponent/basicdata/performance/consumptionComponent.vue';
export default {
    name: 'consumption',
    components: {
        vConsumptionComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>